<template>
  <nav>
    <router-link to="/"></router-link>
  </nav>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  background-color: #f3f5f7 !important;
}

nav {
  padding: 0;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

:root {
  --popper-theme-background-color: #333333 !important;
  --popper-theme-background-color-hover: #333333 !important;
  --popper-theme-text-color: #ffffff !important;
  --popper-theme-border-width: 0px !important;
  --popper-theme-border-style: solid !important;
  --popper-theme-border-radius: 6px !important;
  --popper-theme-padding: 10px !important;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25) !important;
}

.popper {
  min-width: 200px !important;
  font-size: 1rem !important;
  text-align: center !important;
}
</style>
